import { AbstractControl } from '@angular/forms';

export function emptySpacesValidator(control: AbstractControl): { [key: string]: any } | null {
  const name: string | null | undefined = control.value;
  let nameValid: boolean;

  if (!name) {
    return;
  }

  if (!name.replace(/\s/g, '').length) {
    nameValid = false;
  } else {
    nameValid = true;
  }

  return nameValid ? null : { invalidName: { valid: false, value: control.value } };
}
